import React from 'react'
import {
ContainerFluid,HeadingText,Container,ParagraphText,ContainerFluidB,ContainerFluidC
} from './SectionAComponent.style';
function SectionAComponent() {
  return (
    <div>
      <br/><br/>
      <ContainerFluid>
        <Container>
          <div className='row'>
            <div className='col s12 m12 l6'>
              <HeadingText>
                What can I do on the Yalla app?
              </HeadingText>
              <ParagraphText>
                Create unlimited amount of savings plan.
              </ParagraphText>
              <ParagraphText>
              Lock your money for any convenient duration.
              </ParagraphText>
              <ParagraphText>
              Put funds you don’t want to lock in Purse.
              </ParagraphText>
            </div>
          </div>
          
        </Container>
      </ContainerFluid>
      <ContainerFluidB>
        <Container>
        <div className='row'>
            <div className='col s12 m12 l6'>
              <HeadingText>
                How do I know my money is safe? 
              </HeadingText>
              <ParagraphText>
                Fund Asset Allocation: Our user saving funds are invested with our shariah compliant 
                fund managers. Funds are invested in listed and unlisted equities, islamic financial 
                contracts,real estate, shariah compliant investment, sukuk, shariah compliant fixed 
                term investments, murabaha contracts (cost plus financing).  
              </ParagraphText>
              <ParagraphText>
                Regulatory Compliance: Yalla Technologies is a duly registered company with the CAC, 
                RC 1730643. All our funds are held with a third party regulated SEC licensed shariah 
                compliant fund manager. We also have a Lagos State Governemnt Cooperative License 
                (LSCS 17349) that allows us to invest users  funds), Ijarah (lease) contracts. 
              </ParagraphText>
              <ParagraphText>
                Bank Grade Security: Our payment processors are PCI-DSS compliant to ensure
                security of your data electronically. All cards and bank data are encrypted to prevent 
                unauthorised access to sensitive information.
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluidB>
      <ContainerFluidB>
        <Container>
        <div className='row'>
            <div className='col s12 m12 l6'>
              <HeadingText>
              Can I withdraw my money at any time?
              </HeadingText>
              <ParagraphText>
              For your saving plans, you will have to have to wait till your maturity date 
              to withdraw your money. However, you can withdraw the money you have 
              in purse anytime.
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluidB>
      
      <ContainerFluidB>
        <Container>
        <div className='row'>
            <div className='col s12 m12 l6'>
              <HeadingText>
                Are my bank details safe?  
              </HeadingText>
              <ParagraphText>
                Yes they are. Our payment processors are PCI-DSS compliant to ensure security of 
                your data electronically. All cards and bank data are encrypted to prevent unauthorised 
                access to sensitive information.
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluidB>
      <br/><br/>
      <ContainerFluidC className=''>
        <Container>
          <div className='row mt-100'>
            <div className='col s12 m12 l7'>
              <br/><br/><br/>
            </div>
          </div>
        </Container>
      </ContainerFluidC>
    </div>
  )
}

export default SectionAComponent